// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".amp-layout__wrapper .footer-logo__wrapper{margin:30px 0}.amp-layout__wrapper .footer-logo__wrapper .footer-logo{display:block;width:100px;margin:0 auto}", ""]);
// Exports
module.exports = exports;
